/**
 * EpiServer Forms Submission Spinner
 *
 * Makes some heavy assumptions about the content of SubmitButtonElementBlock.cshtml
 */

// Utilities
import debug from "debug";
const MODULE_NAME = 'submit-spinner';
const log = debug(MODULE_NAME);

// Constants
const ICON_SELECTOR = '.button__icon > .icon';
const INITIAL_ICON = 'icon--arrow-right';
const PROGRESS_ICON = 'icon--loading';
const PROGRESS_CLASSES = ['button--icon-spins', 'button--has-progress'];

class SubmitSpinner {
	constructor() {
		this.watch();
	}

	onStartSubmitting(event) {
		log('onStartSubmitting', $(this).get(0), event);

		const $submitButton = $(this).find('[type=submit]');
		$submitButton.attr('disabled','disabled');
		PROGRESS_CLASSES.forEach(function(progressClass) {
			$submitButton.addClass(progressClass);
		});

		const $buttonIcon = $submitButton.find(ICON_SELECTOR);
		$buttonIcon.removeClass(INITIAL_ICON);
		$buttonIcon.addClass(PROGRESS_ICON);
	}

	onSubmitted(event) {
		log('onSubmitted', $(this).get(0), event);

		const $submitButton = $(this).find('[type=submit]');
		$submitButton.removeAttr('disabled');
		PROGRESS_CLASSES.forEach(function(progressClass) {
			$submitButton.removeClass(progressClass);
		});

		const $buttonIcon = $submitButton.find(ICON_SELECTOR);
		$buttonIcon.removeClass(PROGRESS_ICON);
		$buttonIcon.addClass(INITIAL_ICON);
	}

	watch() {
		$$epiforms(".EPiServerForms").on("formsStartSubmitting", this.onStartSubmitting);
		$$epiforms(".EPiServerForms").on("formsNavigationNextStep formsReset formsSubmitted formsSubmittedError", this.onSubmitted);
	}

	unwatch() {
		$$epiforms(".EPiServerForms").off("formsStartSubmitting");
		$$epiforms(".EPiServerForms").off("formsNavigationNextStep formsReset formsSubmitted formsSubmittedError");
	}
}

export default function exec() {
	if (typeof $$epiforms !== 'undefined') {
        $$epiforms(document).ready(function myfunction() {
			new SubmitSpinner();
        });
    }
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/epiforms/epiforms__submit-spinner.js